export default "__VITE_ASSET__DYQf250R__"